import { TypePolicy } from '@apollo/client';
import * as graphql from 'generated/graphql';

import { reactiveVariables } from 'modules/common';
import { getEntityAccess } from 'modules/common/layer00/rbacPolicies';



export const Query: TypePolicy = {
  fields: {
    authQuery: {
      read: (existing, { readField }) => {
        const accessToken = readField('accessToken');
        const loggedInUserId = readField('loggedInUserId');
        const authStatus = readField('authStatus');
        const authError = readField('authError');
        const newItem = {
          authStatus,
          accessToken,
          loggedInUserId,
          authError
        };

        return newItem;

      }
    },
    isSuperAdmin: {
      read: () => {
        const isSuperAdmin = reactiveVariables.isLoggedInUserSuperAdmin();
        return isSuperAdmin === 'yes';
      }
    },

    authStatus: {
      read: (): graphql.AuthenticationStatus => {
        const loggedIn = reactiveVariables.isLoggedInVar();

        if (!loggedIn) {
          return 'signedOut';
        }
        return 'signedIn';
      }
    },

    authError: {
      read: () => {
        return null;
      }
    },

    entityAccessPolicy: {
      read: (existing, { cache, variables }) => {
        const loggedInUserQuery: graphql.GetMembershipsQueryHookResult['data'] | null = cache.readQuery({
          query: {
            ...graphql.GetMembershipsDocument
          }
        });
        if (loggedInUserQuery?.loggedInUser?.isSuperAdmin) {
          const access = getEntityAccess([], variables?.options.filter.entityType, true);
          return access;
        }

        const memberships = loggedInUserQuery?.loggedInUser?.person.memberships.filter((node) => node.project.id === variables?.options.filter.controllingGroupId) ?? [];
        if (memberships.length === 0) {
          const access = getEntityAccess([], variables?.options.filter.entityType, false);
          return access;
        }

        const roleNames = memberships.flatMap((node) => {
          return node.roles.map((role) => role.name);
        });

        const access = getEntityAccess(roleNames, variables?.options.filter.entityType);
        return access;

      }
    }

  }
};
